import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./header";
import Footer from "./Home/Footer";
import GuestLoginPopup from "./popupmodel";
import AIChat from "./AIChat/AIChat";
import ScrollToTop from "./scrollToTop";
import MobileBottomNav from "./Navigation/MobileBottomNav";
import "./Home/homepage.css";

const POPUP_SEEN_KEY = "guest_popup_seen";

const ALLOWED_AI_ROUTES = new Set([
  "/",
  "/services",
  "/about",
  "/contact",
  "/blog",
]);

const AppLayout = () => {
  const location = useLocation();
  const [showGuestPopup, setShowGuestPopup] = useState(false);

  const token =
    localStorage.getItem("userAccessToken") ||
    sessionStorage.getItem("userAccessToken");

  const isLoggedIn = token && token !== "undefined" && token !== "null";

  // Check if AI Chat should be visible on current page
  const normalizedPath =
    location.pathname.endsWith("/") && location.pathname.length > 1
      ? location.pathname.slice(0, -1)
      : location.pathname;
  const shouldShowAIChat = ALLOWED_AI_ROUTES.has(normalizedPath.toLowerCase());

  useEffect(() => {
    // Only show popup on home page AND user is not logged in
    if (location.pathname !== "/" || isLoggedIn) return;

    if (localStorage.getItem(POPUP_SEEN_KEY) === "1") return;

    // ✅ Show popup after 1 second delay
    const timer = setTimeout(() => {
      setShowGuestPopup(true);
      localStorage.setItem(POPUP_SEEN_KEY, "1");
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname, isLoggedIn]);

  return (
    <>
      <ScrollToTop />
      <div className="new-home-wrapper" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header />
        <main style={{ flex: 1, minWidth: 0, width: '100%' }}>
          <Outlet />
        </main>
        <Footer />
        <MobileBottomNav />
      </div>

      {/* Only show popup on home page for guest users */}
      {location.pathname === "/" && !isLoggedIn && (
        <GuestLoginPopup
          isOpen={showGuestPopup}
          onClose={() => setShowGuestPopup(false)}
        />
      )}

      {/* Floating MetaFit AI Assistant (only on allowed primary pages) */}
      {shouldShowAIChat && <AIChat />}
    </>
  );
};

export default AppLayout;
